
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue?macro=true";
import { default as indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue?macro=true";
import { default as loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue?macro=true";
import { default as _91orderId_93WQsJzBoh2xIdovUCVYPOdVz5fGOj5uLlrOdOn7jxqJYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue?macro=true";
import { default as _91orderId_93ayO9x5n5VuJBJB3c61ZvlywQ1whkvjpA_45s_K_452GSdAYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue?macro=true";
import { default as redirects6l_45hsHBid4_sEKVKRLfWofWcpu3Ky64kOop9UmJ1o8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue?macro=true";
import { default as registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue?macro=true";
import { default as _91tab_93XKGPqlGi7FQKgyLaOC7cUErVD0KWkOFQgy1ThNl87u8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue?macro=true";
import { default as following0waTLjJIeJ0e3gwKozq_45cSqs_45OjiFLeOOpYBp3Fp0v4Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue?macro=true";
import { default as not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue?macro=true";
import { default as club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue?macro=true";
import { default as indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue?macro=true";
import { default as _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue?macro=true";
import { default as verify_45emails8qFT7D_45GqLnG1BWEAiHZlyuiCywmlHP6zFawYSVkJcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue?macro=true";
import { default as auth_45redirectzAExDthabPyO5lrO7GpY1w8vZws3fcTEArLj0QI4jUsMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue?macro=true";
import { default as _91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue?macro=true";
import { default as password_45reset4BXz_uhyoGM1bc4GeYhYp4w2ZcNMxYwvaQc2YBklnAoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue?macro=true";
import { default as following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue?macro=true";
import { default as forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue?macro=true";
import { default as indexOY86ckT0JJWKathfL3uu027VJBmYoZeCTifYZlDFm_45MMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue?macro=true";
import { default as _91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue?macro=true";
import { default as index9IOuWqZMrDHKVqqCMHZ441EDfW_np_kLiN8SHy180kQMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue?macro=true";
import { default as _91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue?macro=true";
import { default as _91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue?macro=true";
import { default as indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue?macro=true";
import { default as indextKQIQ67FjHOPBM3nD45L4RhdYLXiQOnm32YRC7rGyKYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue?macro=true";
import { default as indexRzHY0dbgGeA0NxXvUrSNIIG5TpP_45yHaVa9vBenQEalkMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue?macro=true";
import { default as addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue?macro=true";
import { default as _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue?macro=true";
import { default as redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue?macro=true";
import { default as indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue?macro=true";
import { default as redirect9mzDw7v6VLMbIQBfRcmM6b2uO_45fMTuqAEmpvUCrJub0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue?macro=true";
import { default as _91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue?macro=true";
import { default as _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue?macro=true";
import { default as add_45new_45cardNQz5AZyN8XXRi9NTOv4q_45_gP8Odanzry2Jy20GUXHF0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue?macro=true";
import { default as _91certificateNumber_93WkW0QVeEnrzo7qN2U2VGjQOa5wQYEIzvcCiZLK_45gUXIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue?macro=true";
import { default as indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue?macro=true";
import { default as delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue?macro=true";
import { default as account_45detailsGezX_454U9yJwdPbakLFrU76IVSNUipAyKKolWtuO77aoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue?macro=true";
import { default as indexFRM3W4WfstoIlhm2orP01OF_45frce7T2gBOquVFIJoOoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue?macro=true";
import { default as _91orderId_93TlxkByjnDHxsRaXwQQaVRpWopM0c0MqBPzcNjjtdLvoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue?macro=true";
import { default as _91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue?macro=true";
import { default as create_45new_45address91hCYiZXR1U1zb4mfD_MGreDngO_45IW7ouNOlEQjXbnoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue?macro=true";
import { default as _91addressId_93Ug3qNwlB5BmaLmf_1_nuSsc1jzan97k2067gaE1dct0Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue?macro=true";
import { default as component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "live___en___default",
    path: "/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___en",
    path: "/en/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___us",
    path: "/us/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___nl",
    path: "/nl/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___fr",
    path: "/fr/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___de",
    path: "/de/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___it",
    path: "/it/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___id",
    path: "/id/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___es",
    path: "/es/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___pt",
    path: "/pt/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___br",
    path: "/br/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___ja",
    path: "/ja/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___zh",
    path: "/zh/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___tr",
    path: "/tr/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "live___ko",
    path: "/ko/live",
    meta: { ...(livekEaJ05ZjQ03tBjK263EhatM56a6P7iLoLpLZjxNXghcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/live.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___us",
    path: "/us",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___br",
    path: "/br",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: { ...(indexClJnZmMJBI0jzuFIQMlZ4JLM4Vd_NzV3D_455fP5miQjgMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___us",
    path: "/us/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___id",
    path: "/id/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___br",
    path: "/br/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___zh",
    path: "/zh/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "login___ko",
    path: "/ko/login",
    meta: loginUXAFU3_452MdeXqPiuTvC3VjaaUtMcW4ceqGfWGOHxkdYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/login.vue")
  },
  {
    name: "redirect___en___default",
    path: "/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___en___default",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___en___default",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___en",
    path: "/en/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___en",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___en",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___us",
    path: "/us/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___us",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___us",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___nl",
    path: "/nl/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___nl",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___nl",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___fr",
    path: "/fr/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___fr",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___fr",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___de",
    path: "/de/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___de",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___de",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___it",
    path: "/it/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___it",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___it",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___id",
    path: "/id/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___id",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___id",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___es",
    path: "/es/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___es",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___es",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___pt",
    path: "/pt/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___pt",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___pt",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___br",
    path: "/br/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___br",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___br",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___ja",
    path: "/ja/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___ja",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___ja",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___zh",
    path: "/zh/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___zh",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___zh",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___tr",
    path: "/tr/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___tr",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___tr",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___ko",
    path: "/ko/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___ko",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___ko",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___us",
    path: "/us/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___nl",
    path: "/nl/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___id",
    path: "/id/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___pt",
    path: "/pt/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___br",
    path: "/br/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___ja",
    path: "/ja/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___zh",
    path: "/zh/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___tr",
    path: "/tr/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "register___ko",
    path: "/ko/register",
    meta: registerpFvt_jYdfIjFnbJkr7mknWamDkm4GhUDIR8xZqvxOcwMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/register.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___us",
    path: "/us/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___id",
    path: "/id/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___br",
    path: "/br/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___zh",
    path: "/zh/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___tr",
    path: "/tr/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93QeOPafiApLbJfdqa2W7EkCRHjvMa6eM3cmfXb3TdPE0Meta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/[...slug].vue")
  },
  {
    name: "following___en___default",
    path: "/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___en___default",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___en",
    path: "/en/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___en",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___us",
    path: "/us/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___us",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___nl",
    path: "/nl/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___nl",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___fr",
    path: "/fr/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___fr",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___de",
    path: "/de/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___de",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___it",
    path: "/it/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___it",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___id",
    path: "/id/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___id",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___es",
    path: "/es/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___es",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___pt",
    path: "/pt/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___pt",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___br",
    path: "/br/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___br",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___ja",
    path: "/ja/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___ja",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___zh",
    path: "/zh/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___zh",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___tr",
    path: "/tr/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___tr",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___ko",
    path: "/ko/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following.vue"),
    children: [
  {
    name: "following-tab___ko",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following/[tab].vue")
  }
]
  },
  {
    name: "not-found___en___default",
    path: "/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___en",
    path: "/en/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___us",
    path: "/us/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___nl",
    path: "/nl/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___fr",
    path: "/fr/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___de",
    path: "/de/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___it",
    path: "/it/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___id",
    path: "/id/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___es",
    path: "/es/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___pt",
    path: "/pt/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___br",
    path: "/br/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___ja",
    path: "/ja/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___zh",
    path: "/zh/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___tr",
    path: "/tr/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "not-found___ko",
    path: "/ko/not-found",
    meta: not_45found6aIPczcwjUPRKC6upqdxbzvMOgEfPfRd9bhkHK07ns0Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/not-found.vue")
  },
  {
    name: "club-login___en___default",
    path: "/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___en",
    path: "/en/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___us",
    path: "/us/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___nl",
    path: "/nl/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___fr",
    path: "/fr/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___de",
    path: "/de/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___it",
    path: "/it/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___id",
    path: "/id/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___es",
    path: "/es/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___pt",
    path: "/pt/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___br",
    path: "/br/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___ja",
    path: "/ja/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___zh",
    path: "/zh/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___tr",
    path: "/tr/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "club-login___ko",
    path: "/ko/club-login",
    meta: club_45loginwqrRIKHsYTYrgF9xGuWN8GJaNCOxtQXT4hs8KNRRjTcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/club-login.vue")
  },
  {
    name: "news___en___default",
    path: "/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___us",
    path: "/us/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___nl",
    path: "/nl/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___fr",
    path: "/fr/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/de/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___it",
    path: "/it/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___id",
    path: "/id/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___es",
    path: "/es/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___pt",
    path: "/pt/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___br",
    path: "/br/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___ja",
    path: "/ja/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___zh",
    path: "/zh/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___tr",
    path: "/tr/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news___ko",
    path: "/ko/news",
    meta: indexY44CJpNNoG0XqnygaErWl1wbOytjufgz4Ygi8PZfOvIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/index.vue")
  },
  {
    name: "news-slug___en___default",
    path: "/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___us",
    path: "/us/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___nl",
    path: "/nl/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___fr",
    path: "/fr/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/de/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___id",
    path: "/id/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pt",
    path: "/pt/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___br",
    path: "/br/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ja",
    path: "/ja/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___zh",
    path: "/zh/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___tr",
    path: "/tr/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ko",
    path: "/ko/news/:slug()",
    meta: _91slug_933ssTA8TXbA_EP8L3_45aKCXzMn_wWophCJttU8eIHQUiQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/news/[slug].vue")
  },
  {
    name: "verify-email___en___default",
    path: "/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___us",
    path: "/us/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___nl",
    path: "/nl/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___fr",
    path: "/fr/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___it",
    path: "/it/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___id",
    path: "/id/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/es/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/pt/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___br",
    path: "/br/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___ja",
    path: "/ja/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___zh",
    path: "/zh/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___tr",
    path: "/tr/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "verify-email___ko",
    path: "/ko/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/verify-email.vue")
  },
  {
    name: "auth-redirect___en___default",
    path: "/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___en",
    path: "/en/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___us",
    path: "/us/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___nl",
    path: "/nl/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___fr",
    path: "/fr/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___de",
    path: "/de/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___it",
    path: "/it/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___id",
    path: "/id/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___es",
    path: "/es/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___pt",
    path: "/pt/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___br",
    path: "/br/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___ja",
    path: "/ja/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___zh",
    path: "/zh/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___tr",
    path: "/tr/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___ko",
    path: "/ko/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/auth-redirect.vue")
  },
  {
    name: "landing-slug___en___default",
    path: "/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___en",
    path: "/en/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___us",
    path: "/us/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___nl",
    path: "/nl/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___fr",
    path: "/fr/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___de",
    path: "/de/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___it",
    path: "/it/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___id",
    path: "/id/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___es",
    path: "/es/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___pt",
    path: "/pt/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___br",
    path: "/br/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___ja",
    path: "/ja/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___zh",
    path: "/zh/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___tr",
    path: "/tr/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___ko",
    path: "/ko/landing/:slug()",
    meta: { ...(_91slug_93QgrhtlceXgl0YKOIvSMEp7PoA4Zs__45oHialNnP6GBgwMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/landing/[slug].vue")
  },
  {
    name: "password-reset___en___default",
    path: "/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/en/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___us",
    path: "/us/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___it",
    path: "/it/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___id",
    path: "/id/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___es",
    path: "/es/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___pt",
    path: "/pt/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___br",
    path: "/br/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___ja",
    path: "/ja/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___zh",
    path: "/zh/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___tr",
    path: "/tr/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "password-reset___ko",
    path: "/ko/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/password-reset.vue")
  },
  {
    name: "following-login___en___default",
    path: "/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___en",
    path: "/en/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___us",
    path: "/us/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___nl",
    path: "/nl/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___fr",
    path: "/fr/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___de",
    path: "/de/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___it",
    path: "/it/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___id",
    path: "/id/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___es",
    path: "/es/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___pt",
    path: "/pt/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___br",
    path: "/br/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___ja",
    path: "/ja/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___zh",
    path: "/zh/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___tr",
    path: "/tr/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "following-login___ko",
    path: "/ko/following-login",
    meta: following_45loginwVY4DFFZEWtrfPEWLJ4XFfBXe1QPmVXj4l8OypLNyXcMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/following-login.vue")
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___us",
    path: "/us/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___nl",
    path: "/nl/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___id",
    path: "/id/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pt",
    path: "/pt/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___br",
    path: "/br/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ja",
    path: "/ja/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___zh",
    path: "/zh/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___tr",
    path: "/tr/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ko",
    path: "/ko/forgot-password",
    meta: forgot_45passwordbpwzQCJNXJ5fHv4YDWJfBxuCSDZ10ejopfW6FUmHQUIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/forgot-password.vue")
  },
  {
    name: "my-account___en___default",
    path: "/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___en",
    path: "/en/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___us",
    path: "/us/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___nl",
    path: "/nl/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___fr",
    path: "/fr/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___de",
    path: "/de/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___it",
    path: "/it/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___id",
    path: "/id/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___es",
    path: "/es/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___pt",
    path: "/pt/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___br",
    path: "/br/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___ja",
    path: "/ja/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___zh",
    path: "/zh/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___tr",
    path: "/tr/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "my-account___ko",
    path: "/ko/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/index.vue")
  },
  {
    name: "event-eventSlug___en___default",
    path: "/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___en",
    path: "/en/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___us",
    path: "/us/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___nl",
    path: "/nl/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___fr",
    path: "/fr/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___de",
    path: "/de/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___it",
    path: "/it/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___id",
    path: "/id/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___es",
    path: "/es/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___pt",
    path: "/pt/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___br",
    path: "/br/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___ja",
    path: "/ja/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___zh",
    path: "/zh/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___tr",
    path: "/tr/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___ko",
    path: "/ko/event/:eventSlug()",
    meta: { ...(_91eventSlug_930qj94vxqIa0pEhOheHKV8V7GuROk2BXY3FEsy2s0IegMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/event/[eventSlug].vue")
  },
  {
    name: "authenticate___en___default",
    path: "/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___en",
    path: "/en/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___us",
    path: "/us/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___nl",
    path: "/nl/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___fr",
    path: "/fr/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___de",
    path: "/de/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___it",
    path: "/it/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___id",
    path: "/id/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___es",
    path: "/es/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___pt",
    path: "/pt/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___br",
    path: "/br/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___ja",
    path: "/ja/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___zh",
    path: "/zh/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___tr",
    path: "/tr/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "authenticate___ko",
    path: "/ko/authenticate",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/index.vue")
  },
  {
    name: "all-products-slug___en___default",
    path: "/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___en",
    path: "/en/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___us",
    path: "/us/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___nl",
    path: "/nl/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___fr",
    path: "/fr/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___de",
    path: "/de/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___it",
    path: "/it/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___id",
    path: "/id/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___es",
    path: "/es/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___pt",
    path: "/pt/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___br",
    path: "/br/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___ja",
    path: "/ja/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___zh",
    path: "/zh/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___tr",
    path: "/tr/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___ko",
    path: "/ko/all-products/:slug?",
    meta: { ...(_91_91slug_93_93lkgNVrpIHPwe3pzgDN9myJM0tTtcfIBHNQ0VG1XbyN0Meta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/all-products/[[slug]].vue")
  },
  {
    name: "category-categorySlug___en___default",
    path: "/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___en",
    path: "/en/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___us",
    path: "/us/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___nl",
    path: "/nl/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___fr",
    path: "/fr/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___de",
    path: "/de/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___it",
    path: "/it/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___id",
    path: "/id/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___es",
    path: "/es/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___pt",
    path: "/pt/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___br",
    path: "/br/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___ja",
    path: "/ja/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___zh",
    path: "/zh/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___tr",
    path: "/tr/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___ko",
    path: "/ko/category/:categorySlug()",
    meta: { ...(_91categorySlug_939LvdeCFO_45ZpMUxrh06Oe6W3KidtmJfcUBW9xQo5lOR8Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/category/[categorySlug].vue")
  },
  {
    name: "checkout-orderId___en___default",
    path: "/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___en",
    path: "/en/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___us",
    path: "/us/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___nl",
    path: "/nl/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___fr",
    path: "/fr/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___de",
    path: "/de/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___it",
    path: "/it/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___id",
    path: "/id/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___es",
    path: "/es/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___pt",
    path: "/pt/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___br",
    path: "/br/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___ja",
    path: "/ja/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___zh",
    path: "/zh/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___tr",
    path: "/tr/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___ko",
    path: "/ko/checkout/:orderId()",
    meta: { ...(indexc9eqLxuWmIMpdjAYE5fnpX4jBiB7XNgtsgCrXWwQG1wMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "my-account-payment___en___default",
    path: "/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___en",
    path: "/en/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___us",
    path: "/us/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___nl",
    path: "/nl/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___fr",
    path: "/fr/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___de",
    path: "/de/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___it",
    path: "/it/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___id",
    path: "/id/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___es",
    path: "/es/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___pt",
    path: "/pt/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___br",
    path: "/br/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___ja",
    path: "/ja/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___zh",
    path: "/zh/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___tr",
    path: "/tr/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___ko",
    path: "/ko/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-settings___en___default",
    path: "/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___en",
    path: "/en/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___us",
    path: "/us/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___nl",
    path: "/nl/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___fr",
    path: "/fr/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___de",
    path: "/de/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___it",
    path: "/it/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___id",
    path: "/id/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___es",
    path: "/es/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___pt",
    path: "/pt/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___br",
    path: "/br/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___ja",
    path: "/ja/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___zh",
    path: "/zh/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___tr",
    path: "/tr/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___ko",
    path: "/ko/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/index.vue")
  },
  {
    name: "checkout-orderId-address___en___default",
    path: "/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___en",
    path: "/en/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___us",
    path: "/us/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___nl",
    path: "/nl/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___fr",
    path: "/fr/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___de",
    path: "/de/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___it",
    path: "/it/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___id",
    path: "/id/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___es",
    path: "/es/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___pt",
    path: "/pt/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___br",
    path: "/br/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___ja",
    path: "/ja/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___zh",
    path: "/zh/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___tr",
    path: "/tr/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___ko",
    path: "/ko/checkout/:orderId()/address",
    meta: { ...(addressmFDOxZZ5mIr3yCiJ_3XC2G3aeTaUzUQy5A7ydLDrPLUMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "my-account-my-bids-tab___en___default",
    path: "/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___en",
    path: "/en/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___us",
    path: "/us/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___nl",
    path: "/nl/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___fr",
    path: "/fr/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___de",
    path: "/de/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___it",
    path: "/it/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___id",
    path: "/id/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___es",
    path: "/es/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___pt",
    path: "/pt/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___br",
    path: "/br/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___ja",
    path: "/ja/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___zh",
    path: "/zh/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___tr",
    path: "/tr/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___ko",
    path: "/ko/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93tGzoA9X9je0GglOEttx5lKVxYTlMBBbmw_1StwwB7h8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "checkout-orderId-redirect___en___default",
    path: "/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___en",
    path: "/en/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___us",
    path: "/us/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___nl",
    path: "/nl/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___fr",
    path: "/fr/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___de",
    path: "/de/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___it",
    path: "/it/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___id",
    path: "/id/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___es",
    path: "/es/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___pt",
    path: "/pt/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___br",
    path: "/br/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___ja",
    path: "/ja/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___zh",
    path: "/zh/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___tr",
    path: "/tr/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___ko",
    path: "/ko/checkout/:orderId()/redirect",
    meta: { ...(redirectAaQUWUODGDWNB9ovuvthcUbQBIMRXjghhrcUfOzS7hIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "my-account-my-profile___en___default",
    path: "/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___en",
    path: "/en/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___us",
    path: "/us/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___nl",
    path: "/nl/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___fr",
    path: "/fr/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___de",
    path: "/de/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___it",
    path: "/it/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___id",
    path: "/id/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___es",
    path: "/es/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___pt",
    path: "/pt/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___br",
    path: "/br/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___ja",
    path: "/ja/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___zh",
    path: "/zh/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___tr",
    path: "/tr/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___ko",
    path: "/ko/my-account/my-profile",
    meta: indexinIPDe_45nr3FUn4AVWaWccZhzl5NAmUSLXfLImbmQD9UMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-payment-redirect___en___default",
    path: "/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___en",
    path: "/en/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___us",
    path: "/us/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___nl",
    path: "/nl/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___fr",
    path: "/fr/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___de",
    path: "/de/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___it",
    path: "/it/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___id",
    path: "/id/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___es",
    path: "/es/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___pt",
    path: "/pt/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___br",
    path: "/br/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___ja",
    path: "/ja/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___zh",
    path: "/zh/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___tr",
    path: "/tr/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___ko",
    path: "/ko/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/redirect.vue")
  },
  {
    name: "product-productIdentifier___en___default",
    path: "/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___en",
    path: "/en/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___us",
    path: "/us/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___nl",
    path: "/nl/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___fr",
    path: "/fr/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___de",
    path: "/de/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___it",
    path: "/it/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___id",
    path: "/id/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___es",
    path: "/es/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___pt",
    path: "/pt/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___br",
    path: "/br/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___ja",
    path: "/ja/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___zh",
    path: "/zh/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___tr",
    path: "/tr/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___ko",
    path: "/ko/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93g6rfV05NQy4jwd46_45sMsQgByfafDuFt8N4lgD6wnjlIMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/product/[productIdentifier].vue")
  },
  {
    name: "search-searchTerm-tab___en___default",
    path: "/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___en",
    path: "/en/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___us",
    path: "/us/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___nl",
    path: "/nl/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___fr",
    path: "/fr/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___de",
    path: "/de/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___it",
    path: "/it/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___id",
    path: "/id/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___es",
    path: "/es/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___pt",
    path: "/pt/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___br",
    path: "/br/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___ja",
    path: "/ja/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___zh",
    path: "/zh/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___tr",
    path: "/tr/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "search-searchTerm-tab___ko",
    path: "/ko/search/:searchTerm()/:tab?",
    meta: _91_91tab_93_93i_45dTPwUnJVlAxV9S18nrpl4qSKkIm_45geWbDiUGjyeT8Meta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/search/[searchTerm]/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___en___default",
    path: "/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___en",
    path: "/en/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___us",
    path: "/us/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___nl",
    path: "/nl/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___fr",
    path: "/fr/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___de",
    path: "/de/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___it",
    path: "/it/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___id",
    path: "/id/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___es",
    path: "/es/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___pt",
    path: "/pt/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___br",
    path: "/br/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___ja",
    path: "/ja/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___zh",
    path: "/zh/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___tr",
    path: "/tr/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___ko",
    path: "/ko/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93GkOY_45sVAgsKDQUUVfnPxZhRDiffoKlARUVY65Jewh8IMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-payment-add-new-card___en___default",
    path: "/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___en",
    path: "/en/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___us",
    path: "/us/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___nl",
    path: "/nl/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___fr",
    path: "/fr/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___de",
    path: "/de/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___it",
    path: "/it/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___id",
    path: "/id/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___es",
    path: "/es/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___pt",
    path: "/pt/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___br",
    path: "/br/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___ja",
    path: "/ja/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___zh",
    path: "/zh/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___tr",
    path: "/tr/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___ko",
    path: "/ko/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "authenticate-certificateNumber___en___default",
    path: "/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___en",
    path: "/en/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___us",
    path: "/us/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___nl",
    path: "/nl/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___fr",
    path: "/fr/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___de",
    path: "/de/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___it",
    path: "/it/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___id",
    path: "/id/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___es",
    path: "/es/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___pt",
    path: "/pt/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___br",
    path: "/br/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___ja",
    path: "/ja/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___zh",
    path: "/zh/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___tr",
    path: "/tr/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___ko",
    path: "/ko/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "checkout-orderId-payment___en___default",
    path: "/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___en",
    path: "/en/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___us",
    path: "/us/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___nl",
    path: "/nl/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___fr",
    path: "/fr/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___de",
    path: "/de/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___it",
    path: "/it/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___id",
    path: "/id/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___es",
    path: "/es/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___pt",
    path: "/pt/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___br",
    path: "/br/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___ja",
    path: "/ja/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___zh",
    path: "/zh/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___tr",
    path: "/tr/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___ko",
    path: "/ko/checkout/:orderId()/payment",
    meta: { ...(indexHzSTMrcvoZvFCuwogmRJg4kZEps_U2XZ6yMaxougljYMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "my-account-settings-delete-account___en___default",
    path: "/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___en",
    path: "/en/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___us",
    path: "/us/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___nl",
    path: "/nl/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___fr",
    path: "/fr/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___de",
    path: "/de/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___it",
    path: "/it/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___id",
    path: "/id/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___es",
    path: "/es/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___pt",
    path: "/pt/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___br",
    path: "/br/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___ja",
    path: "/ja/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___zh",
    path: "/zh/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___tr",
    path: "/tr/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___ko",
    path: "/ko/my-account/settings/delete-account",
    meta: delete_45accountUIFl_5ZHv4N9H296INkn82Zw7DNh4j_45B5R9eMAB7IRYMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-account-details___en___default",
    path: "/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___en",
    path: "/en/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___us",
    path: "/us/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___nl",
    path: "/nl/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___fr",
    path: "/fr/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___de",
    path: "/de/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___it",
    path: "/it/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___id",
    path: "/id/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___es",
    path: "/es/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___pt",
    path: "/pt/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___br",
    path: "/br/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___ja",
    path: "/ja/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___zh",
    path: "/zh/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___tr",
    path: "/tr/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___ko",
    path: "/ko/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-addresses___en___default",
    path: "/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___en",
    path: "/en/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___us",
    path: "/us/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___nl",
    path: "/nl/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___fr",
    path: "/fr/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___de",
    path: "/de/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___it",
    path: "/it/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___id",
    path: "/id/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___es",
    path: "/es/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___pt",
    path: "/pt/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___br",
    path: "/br/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___ja",
    path: "/ja/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___zh",
    path: "/zh/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___tr",
    path: "/tr/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___ko",
    path: "/ko/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-my-orders-order-orderId___en___default",
    path: "/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___en",
    path: "/en/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___us",
    path: "/us/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___nl",
    path: "/nl/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___fr",
    path: "/fr/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___de",
    path: "/de/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___it",
    path: "/it/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___id",
    path: "/id/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___es",
    path: "/es/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___pt",
    path: "/pt/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___br",
    path: "/br/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___ja",
    path: "/ja/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___zh",
    path: "/zh/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___tr",
    path: "/tr/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___ko",
    path: "/ko/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___en___default",
    path: "/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___en",
    path: "/en/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___us",
    path: "/us/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___nl",
    path: "/nl/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___fr",
    path: "/fr/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___de",
    path: "/de/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___it",
    path: "/it/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___id",
    path: "/id/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___es",
    path: "/es/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___pt",
    path: "/pt/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___br",
    path: "/br/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___ja",
    path: "/ja/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___zh",
    path: "/zh/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___tr",
    path: "/tr/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___ko",
    path: "/ko/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_935_ZTSLm7QmTzUNCW3T2eo1r6KRfh9hfGoa3HzwFSYD8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___en___default",
    path: "/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___en",
    path: "/en/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___us",
    path: "/us/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___nl",
    path: "/nl/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___fr",
    path: "/fr/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___de",
    path: "/de/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___it",
    path: "/it/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___id",
    path: "/id/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___es",
    path: "/es/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___pt",
    path: "/pt/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___br",
    path: "/br/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___ja",
    path: "/ja/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___zh",
    path: "/zh/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___tr",
    path: "/tr/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___ko",
    path: "/ko/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___en___default",
    path: "/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___en",
    path: "/en/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___us",
    path: "/us/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___nl",
    path: "/nl/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___fr",
    path: "/fr/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___de",
    path: "/de/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___it",
    path: "/it/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___id",
    path: "/id/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___es",
    path: "/es/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___pt",
    path: "/pt/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___br",
    path: "/br/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___ja",
    path: "/ja/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___zh",
    path: "/zh/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___tr",
    path: "/tr/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___ko",
    path: "/ko/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/us/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/id/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/br/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  },
  {
    name: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMAMeta?.name,
    path: "/ko/sitemap.xml",
    component: component_45stub15vo7QkyZsaBKhryrT4VpkrPSqFUxp1piDtp4D71oMA
  }
]